import constants from '@/app-configs/constants'

export default [
  {
    path: '/statement-groups',
    name: 'statement-groups',
    component: () => import('@/views/statementGroups/statementGroups.vue'),
    meta: {
      pageTitle: 'DEBTIA_STATEMENT_GROUPS',
      breadcrumb: [
        {
          text: 'DEBTIA_STATEMENT_GROUPS',
          active: true,
        },
      ],
      action: constants.action.permissionStatementGroupView,
      resource: constants.resource.statementGroups,
      companyOnly: true,
    },
  },
]
